var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocationPinIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01367 1.39978C10.4002 1.39996 12.3467 3.34721 12.3467 5.73376C12.3466 6.36703 12.1663 7.16709 11.873 7.88025C11.0729 9.80705 8.54025 13.8602 8.43359 14.0336L8.00684 14.7064L7.58008 14.0336C7.47341 13.8602 4.93303 9.80029 4.13965 7.88025C3.83972 7.16042 3.66708 6.36036 3.66699 5.73376C3.66699 3.3471 5.61333 1.39978 8 1.39978H8.01367ZM8 2.40662C6.16012 2.40662 4.66718 3.89978 4.66699 5.73962C4.66699 6.33296 4.86624 7.04037 5.05957 7.50037C5.63292 8.88697 7.23329 11.5528 8 12.8129C8.77337 11.5528 10.3671 8.88697 10.9404 7.50037C11.1271 7.04037 11.333 6.33296 11.333 5.73962C11.3328 3.89978 9.83988 2.40662 8 2.40662ZM8 3.3197C9.32667 3.3197 10.4131 4.4071 10.4131 5.73376C10.4128 7.06023 9.32652 8.14685 8 8.14685C6.67349 8.14685 5.58716 7.06022 5.58691 5.73376C5.58691 4.4071 6.66667 3.3197 8 3.3197ZM8 4.32654C7.22012 4.32654 6.58711 4.95979 6.58691 5.73962C6.58691 6.51962 7.22 7.15369 8 7.15369C8.78 7.15369 9.41309 6.51962 9.41309 5.73962C9.4129 4.95979 8.77988 4.32654 8 4.32654Z",
    fill: "#7D7D7D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocationPinIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Location_Pin_Icon.cb1b5a8d8d4db94becffffea006577ba.svg";